/* unplugin-vue-components disabled */import script from "./Jyjczx.vue?vue&type=script&lang=ts&setup=true"
export * from "./Jyjczx.vue?vue&type=script&lang=ts&setup=true"

import "./Jyjczx.vue?vue&type=style&index=0&id=c3b74932&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3b74932"]])

export default __exports__